import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { catchError, throwError } from 'rxjs'
import { ErrorMsg } from '../model/inko-backend.model'

/**
 * Fehlercodes, die der Aufrufer dieses einen Requests selbst behandelt — fuer sie oeffnet der
 * Interceptor seinen Dialog nicht.
 *
 * <p>Gedacht fuer Codes, die gar keine Fehlermeldung sind, sondern eine Rueckfrage: das Backend
 * lehnt ab und sagt dazu, dass derselbe Request mit einer Bestaetigung durchginge (Kassenwechsel).
 * Ohne das hier saehe der Bediener erst „geht nicht" und danach „trotzdem?" — zwei Dialoge, die
 * sich widersprechen.</p>
 *
 * <p><b>Bewusst eine Liste von Codes und kein Schalter „Dialog aus":</b> ein abgeschalteter Dialog
 * verschluckt auch den 500er, der aus demselben Aufruf kommen kann, und der Bediener sieht dann
 * gar nichts. Genannt wird deshalb genau das, was die aufrufende Stelle wirklich abfaengt.</p>
 */
export const SELBST_BEHANDELTE_FEHLER = new HttpContextToken<readonly string[]>(() => [])

export const errorMsgInterceptor: HttpInterceptorFn = (req, next) => {
  const dialog = inject(MatDialog)
  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status >= 300 && err.headers.get('X-Error') === 'true') {
          const payload: ErrorMsg = err?.error
          const selbstBehandelt = payload?.type != null && req.context.get(SELBST_BEHANDELTE_FEHLER).includes(payload.type)
          if (!selbstBehandelt) {
            // Texte und Dialog nachgeladen, damit sie nicht im Initial-Bundle liegen (error-msg-dialog.component.ts)
            void import('./error-msg-dialog.component').then((m) => dialog.open(m.ErrorMsgDialogComponent, { data: payload }))
          }
        }
      }
      return throwError(() => err)
    }),
  )
}
